import { render, staticRenderFns } from "./ReviewRequestDialog.vue?vue&type=template&id=5f4cc9b6"
import script from "./ReviewRequestDialog.vue?vue&type=script&lang=ts"
export * from "./ReviewRequestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports